module.exports = __webpack_public_path__ + "img/martin_icon.1506fb39.png";